export const ENV = process.env.REACT_APP_ENVIROMENT;